import React, { useEffect, useState } from 'react';

//Material Imports
import {
    Alert,
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Snackbar,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTheme } from '@mui/material/styles';

//Icon Imports
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PaymentsIcon from '@mui/icons-material/Payments';

//Project Imports
import MainCard from 'ui-component/cards/MainCard';
import NoResults from 'assets/images/noresults.png';
import SEFieldExpenses from './SESalarySlabItems';
import useSESalarySlabsService from 'services/useSESalarySlabsService';
import useSESalarySlabItemsService from 'services/useSESalarySlabItemsService';

const SESalarySlab = () => {
    //Constants
    const theme = useTheme();
    const { getSESalarySlab, updateSESalarySlab } = useSESalarySlabsService();
    const { getSESalarySlabItems, softDeleteSESalarySlabItems } = useSESalarySlabItemsService();

    //States
    const [loading, setLoading] = useState(false);
    const [loadingSESalarySlab, setLoadingSESalarySlab] = useState(false);
    const [seSalarySlabDetails, setSESalarySlabDetails] = useState([]);
    const [seSalarySlabItemsDetails, setSESalarySlabItemsDetails] = useState([]);

    const [selectedSESalarySlabItems, setSelectedSESalarySlabItems] = useState('');
    const [openForm, setOpenForm] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openToast, setOpenToast] = useState(false);

    const [seFixedSalary, setSEFixedSalary] = useState('');

    // Methods

    const handleCancel = () => {
        setOpenForm(false);
    };

    const handleSave = () => {
        getSESalarySlabItemsList();
    };

    const handleCloseToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenToast(false);
    };

    const getSESalarySlabList = () => {
        setSESalarySlabDetails(undefined);
        getSESalarySlab()
            .then((response) => {
                console.log(response);
                setSESalarySlabDetails(response.data.list);
                setSEFixedSalary(response.data.list[0].fixedSalary);
            })
            .catch((error) => setIsError(error.message));
    };
    const getSESalarySlabItemsList = () => {
        setSESalarySlabItemsDetails(undefined);
        getSESalarySlabItems()
            .then((response) => {
                console.log(response);
                setSESalarySlabItemsDetails(response.data.list);
            })
            .catch((error) => setIsError(error.message));
    };
    const handleDelete = () => {
        setLoading(true);
        softDeleteSESalarySlabItems(selectedSESalarySlabItems.id)
            .then((response) => {
                getSESalarySlabItemsList();
                setOpenToast(true);
                setOpenDeleteDialog(false);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setOpenDeleteDialog(false);
            });
    };

    const handleUpdate = () => {
        setLoadingSESalarySlab(true);
        let data = {
            fixedSalary: seFixedSalary
        };
        updateSESalarySlab(seSalarySlabDetails[0].id, data).then((response) => {
            setLoadingSESalarySlab(false);
            console.log('UPDATE CALL', response);
        });
    };

    //UseEffects
    useEffect(() => {
        getSESalarySlabList();
        getSESalarySlabItemsList();
    }, []);
    return (
        <>
            <MainCard>
                <CardHeader title="SE Salary Slabs" avatar={<PaymentsIcon color="primary" />} sx={{ padding: 0 }} />
                <Divider sx={{ marginY: 3 }} />
                <Grid container spacing={2} direction="row" sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Grid item sm={2} xs={12}>
                        <Typography variant="h5">Fixed Salary :</Typography>
                    </Grid>
                    {seFixedSalary != undefined || seFixedSalary != null ? (
                        <Grid item sm={4} xs={12}>
                            <TextField
                                id="Fixed Salary"
                                type="number"
                                name="seFixedSalary"
                                label="Fixed Salary"
                                variant="outlined"
                                value={seFixedSalary}
                                fullWidth
                                onChange={(event) => {
                                    setSEFixedSalary(event.target.value);
                                    //console.log(abmFixeSalary);
                                }}
                            ></TextField>
                        </Grid>
                    ) : null}

                    <Grid item sm={4} xs={12}>
                        <LoadingButton
                            loading={loadingSESalarySlab}
                            onClick={() => {
                                handleUpdate();
                            }}
                            variant="contained"
                        >
                            Update
                        </LoadingButton>
                    </Grid>
                </Grid>
                <Divider sx={{ marginY: 2 }} />

                <Grid container justifyContent="center" alignItems="center" spacing={2}>
                    <Grid item sm={6} xs={6} align="left">
                        <Typography variant="h5">SE Field Expenses</Typography>
                    </Grid>
                    <Grid item align="right" sm={6}>
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<AddIcon />}
                            align="right"
                            onClick={() => {
                                setSelectedSESalarySlabItems({
                                    id: 0,
                                    seSalarySlabId: 0,
                                    unitMin: 0,
                                    unitMax: 0,
                                    fieldExpenses: 0,
                                    pri: 0,
                                    da: 0,
                                    ta: 0
                                });
                                setOpenForm(true);
                            }}
                        >
                            Add
                        </Button>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        {seSalarySlabItemsDetails != undefined || seSalarySlabItemsDetails != null ? (
                            <>
                                {seSalarySlabItemsDetails?.length === 0 ? (
                                    <Grid align="center" sx={{ mt: 5, mb: 5 }}>
                                        <img src={NoResults} alt="No Result" width="150px" />
                                        <Typography variant="h4" fontWeight={100}>
                                            There are no SE salary slab item details found
                                        </Typography>
                                    </Grid>
                                ) : (
                                    <>
                                        <Grid
                                            item
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            sx={{ display: { xs: 'none', sm: 'block', md: 'block', xl: 'block' } }}
                                        >
                                            <TableContainer>
                                                <Table
                                                    sx={{
                                                        border: 'solid',
                                                        borderWidth: 1,
                                                        borderColor: 'divider'
                                                    }}
                                                >
                                                    <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
                                                        <TableRow>
                                                            <TableCell sx={{ width: 70 }}>
                                                                <Typography variant="h5">Sr.No.</Typography>{' '}
                                                            </TableCell>

                                                            <TableCell sx={{ width: 120 }}>
                                                                <Typography variant="h5">Units</Typography>{' '}
                                                            </TableCell>

                                                            <TableCell sx={{ width: 180 }}>
                                                                <Typography variant="h5">Field Expenses / Unit</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ width: 180 }}>
                                                                <Typography variant="h5">PRI / Unit</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ width: 130 }}>
                                                                <Typography variant="h5">D.A / Day</Typography>
                                                            </TableCell>
                                                            <TableCell sx={{ width: 130 }}>
                                                                <Typography variant="h5">T.A / Day</Typography>
                                                            </TableCell>

                                                            <TableCell></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {seSalarySlabItemsDetails?.map((row, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell component="th" scope="row">
                                                                    {index + 1}
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    {row.unitMin} - {row.unitMax}
                                                                </TableCell>

                                                                <TableCell align="left">{row.fieldExpenses}</TableCell>
                                                                <TableCell align="left">{row.pri}</TableCell>
                                                                <TableCell align="left">{row.da}</TableCell>
                                                                <TableCell align="left">{row.ta}</TableCell>

                                                                <TableCell align="right">
                                                                    <Tooltip title="Edit SE Salary Slab Item details">
                                                                        <IconButton
                                                                            variant="outlined"
                                                                            color="primary"
                                                                            size="small"
                                                                            onClick={() => {
                                                                                setSelectedSESalarySlabItems(row);
                                                                                setOpenForm(true);
                                                                            }}
                                                                        >
                                                                            <EditIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="Delete SE Salary Slab Items">
                                                                        <IconButton
                                                                            color="error"
                                                                            size="small"
                                                                            onClick={() => {
                                                                                setSelectedSESalarySlabItems(row);
                                                                                setOpenDeleteDialog(true);
                                                                            }}
                                                                        >
                                                                            <DeleteIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                        {seSalarySlabItemsDetails.map((row, index) => (
                                            <Grid
                                                key={index}
                                                item
                                                xs={12}
                                                sx={{ display: { xs: 'block', sm: 'none', md: 'none', xl: 'none' } }}
                                            >
                                                <Card sx={{ p: 2 }} variant="outlined" key={index}>
                                                    <Stack justifyContent="space-between" direction="row" alignItems="center" spacing={2}>
                                                        <Typography variant="h5">Unit:</Typography>
                                                        <Typography>
                                                            {row.unitMin} - {row.unitMax}
                                                        </Typography>
                                                    </Stack>

                                                    <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                        <Typography variant="h5">Field Expenses:</Typography>
                                                        <Typography>{row.fieldExpenses}</Typography>
                                                    </Stack>
                                                    <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                        <Typography variant="h5">PRI:</Typography>
                                                        <Typography>{row.pri}</Typography>
                                                    </Stack>
                                                    <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                        <Typography variant="h5">D.A:</Typography>
                                                        <Typography>{row.da}</Typography>
                                                    </Stack>
                                                    <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                        <Typography variant="h5">T.A:</Typography>
                                                        <Typography>{row.ta}</Typography>
                                                    </Stack>
                                                    <Divider sx={{ mt: 1 }} />
                                                    <Stack justifyContent="flex-end" direction="row" alignItems="right" sx={{ mt: 2 }}>
                                                        <Tooltip title="Edit SE Salary Slab Item details">
                                                            <IconButton
                                                                variant="outlined"
                                                                color="primary"
                                                                size="small"
                                                                onClick={() => {
                                                                    setSelectedSESalarySlabItems(row);
                                                                    setOpenForm(true);
                                                                }}
                                                            >
                                                                <EditIcon fontSize="inherit" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Delete SE Salary Slab Item">
                                                            <IconButton
                                                                color="error"
                                                                size="small"
                                                                onClick={() => {
                                                                    setSelectedSESalarySlabItems(row);
                                                                    setOpenDeleteDialog(true);
                                                                }}
                                                            >
                                                                <DeleteIcon fontSize="inherit" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Stack>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </>
                                )}
                            </>
                        ) : (
                            <Grid item xs={12} sm={12} md={12} lg={12} align="center">
                                <Stack direction="column" justifyContent="Center" alignItems="center" spacing={2} sx={{ marginY: 3 }}>
                                    <Typography variant="h4" textAlign="center">
                                        Getting List...
                                    </Typography>
                                    <CircularProgress />
                                </Stack>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </MainCard>
            <Dialog open={openForm} onClose={handleCancel} fullWidth maxWidth="sm">
                <DialogContent>
                    <SEFieldExpenses onSave={handleSave} onCancel={handleCancel} selectedSESalarySlabItems={selectedSESalarySlabItems} />
                </DialogContent>
            </Dialog>

            <Dialog
                open={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false);
                }}
                fullWidth
            >
                <DialogTitle>
                    <Typography variant="h4" color={theme.palette.secondary.dark}>
                        Delete SE Salary Slab Item Details
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h5" color={theme.palette.error}>
                        Are you sure you want to delete this SE salary slab item details ?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <LoadingButton
                        loading={loading}
                        onClick={() => {
                            handleDelete();
                        }}
                        variant="contained"
                    >
                        Yes
                    </LoadingButton>
                    <LoadingButton
                        onClick={() => {
                            setOpenDeleteDialog(false);
                        }}
                        variant="outlined"
                    >
                        No
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Snackbar open={openToast} autoHideDuration={6000} onClose={handleCloseToast}>
                <Alert onClose={handleCloseToast} severity="success" sx={{ width: '100%', backgroundColor: theme.palette.success.main }}>
                    <Typography sx={{ color: theme.palette.grey[50] }}> SE salary slab item deleted succesfully!!</Typography>
                </Alert>
            </Snackbar>
        </>
    );
};

export default SESalarySlab;
